const button = document.getElementById('select-lang');
const list = document.querySelector('.nav__langs-list');

const onWindowClick = () => {
  list.classList.remove('active');
  window.removeEventListener('click', onWindowClick);
};

button.addEventListener('click', (evt) => {
  evt.stopPropagation();
  list.classList.toggle('active');
  window.addEventListener('click', onWindowClick);
});
